<template>
  <main>
    <template v-if="!this.showDefaultPage">
      <section class="plan-init">
        <h3 class="title mb-1" v-if="!this.noDocenteDom">
          Estos son los planes y el precio mensual estimado que tenemos para
          vos.
        </h3>
        <h3 class="title" v-else>Este es el plan que tenemos para vos.</h3>
        <br>
        <section class="slider-container" v-if="!this.noDocenteDom">
          <hooper
            :settings="hooperSettings"
            :itemsToShow="4"
            :infiniteScroll="false"
            :trimWhiteSpace="true"
          >
            <slide>
              <PlanCard
                :planType="'uni1000'"
                :title="'UNI1000'"
                :hrColor="'#efefef'"
                :firstPrice="price.uni1000"
                :secondPrice="price.uni1000"
                :allData="forSendData"
                :url_image="'plan-uni1000'"
                :info="[
                  'Cartilla de prestadores equilibrada y accesible.',
                  'Estudios de baja, media y alta complejidad con ACP.',
                  'Odontología general con ACP.',
                  '100% de cobertura en internaciones clínicas y quirúrgicas.',
                  'Emergencias, urgencias y traslados. Médico a domicilio con ACP.',
                  'Prótesis y Órtesis removibles 50%.',
                  'Garantiza la cobertura del PMO.',,
                ]"
              />
            </slide>
            <slide>
              <PlanCard
                :planType="'uni2000'"
                :title="'UNI2000'"
                :hrColor="'#117e96'"
                :firstPrice="price.uni2000"
                :secondPrice="price.descuentoIntegral"
                :allData="forSendData"
                :url_image="'plan-uni2000'"
                :info="[
                  'Cartilla de prestadores equilibrada y accesible.',
                  'Estudios de baja, media y alta complejidad con ACP diferenciados más económicos.',
                  'Odontología general con ACP diferenciados más económicos..',
                  '100% de cobertura en internaciones clínicas y quirúrgicas.',
                  'Emergencias, urgencias y traslados',
                  'Médico a domicilio con ACP.',
                  '40% de desc. en medicamentos.',
                  'Prótesis y Órtesis removibles 50%.',
                  'Garantiza la cobertura del PMO.'
                ]"
              />
            </slide>
            <slide>
              <PlanCard
                :planType="'uni3000'"
                :title="'UNI3000'"
                :hrColor="'#fbb440'"
                :firstPrice="price.uni3000"
                :secondPrice="price.descuentoPremium"
                :allData="forSendData"
                :url_image="'plan-uni3000'"
                :info="[
                     'Cartilla de prestadores equilibrada y accesible.',
                     'Estudios de baja, media y alta complejidad sin ACP.',
                    'Odontología general sin ACP.',
                    '100% de cobertura en internaciones clínicas y quirúrgicas.',
                    'Emergencias, urgencias y traslados.',
                    'Médico a domicilio con ACP.',
                    '50% de desc. en medicamentos.',
                    'Prótesis y Órtesis removibles 50%.',
                     'Garantiza la cobertura del PMO.'
                ]"
              />
            </slide>
            <slide>
              <PlanCard
                :planType="'uni4000'"
                :title="'UNI4000'"
                :hrColor="'#fbb440'"
                :firstPrice="price.uni4000"
                :secondPrice="price.descuentoPremium"
                :allData="forSendData"
                :url_image="'plan-uni4000'"
                :info="[
                  'Cartilla de prestadores amplia y diferenciada.',
                  'Estudios de baja, media y alta complejidad, sin ACP.',
                  'Odontología general, sin ACP.',
                   '100% de cobertura en internaciones clínicas y quirúrgicas.',
                   'Emergencias, urgencias y traslados.',
                   'Médico a domicilio, sin ACP',
                   '50% de desc. en medicamentos.',
                   'Prótesis y Órtesis removibles 100%.',
                   'Garantiza la cobertura del PMO.',
                   'Cobertura nacional.',
                   'Cobertura en el exterior (acceso a Asistencia al viajero).',
                   'Habitación individual.'

                ]"
              />
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
          </hooper>
        </section>
        <section class="slider-container" v-else>
          <div class="plancard-nodocente">
            <PlanCard
              :planType="''"
              :title="'NODOCENTE'"
              :hrColor="'#efefef'"
              :firstPrice="'0'"
              :secondPrice="0"
              :allData="forSendData"
              :info="[
                'Máximo nivel de cobertura sin copagos.',
                'Amplia red de prestadores.',
                'Descuentos en medicamentos del 70% al 100%.',
                '100% de cobertura en internaciones clínicas y quirúrgicas en habitación privada.',
                'Emergencias, urgencias, médico a domicilio y traslados sin copago.',
                'Asistencia al viajero sin cargo.',
                'Sólo con el 3% del aporte personal de ley.',
                'Sin pago de Aporte Complementario Mensual',
              ]"
            />
          </div>
        </section>
      </section>
      <ul class="btn-control">
        <!--
        <li>
          <CustomButton :clickFunction="reCotizar" text="Volver a cotizar" />
        </li>
        -->
        <li>
          <a
            class="center button masInfo is-info"
            href="https://www.osfatun.com.ar/planes/"
            target="_blank"
            >Más información</a
          >
        </li>
      </ul>
      <PlanInfo />
    </template>
    <template v-else>
      <section class="plan-init is-default-page">
        <h3 class="title mb-5">Estos son los planes que tenemos para vos.</h3>
        <section class="slider-container">
          <hooper
            :settings="hooperSettings"
            :itemsToShow="4"
            :infiniteScroll="false"
            :trimWhiteSpace="true"
          >
            <slide>
              <PlanCard
                :planType="'basic'"
                :title="'BÁSICO'"
                :hrColor="'#efefef'"
                :firstPrice="price.basico2"
                :secondPrice="price.descuentoBasico"
                :allData="forSendData"
                :info="[
                  'Cobertura del Programa Médico Obligatorio a bajo costo con copagos.',
                  'Red de prestadores equilibrada y accesible.',
                  'Descuentos en medicamentos del 40% al 100%.',
                  '100% de cobertura en internaciones clínicas y quirúrgicas.',
                  'Emergencias, urgencias, médico a domicilio y traslados con copago.',
                  'Asistencia al viajero con tarifas bonificadas.',
                  'Sólo con el 3% del aporte personal de ley a partir del mínimo del plan.',
                  'Posibilidad de ascender de plan mediante el pago de un Aporte Complementario Mensual.',
                ]"
              />
            </slide>
            <slide>
              <PlanCard
                :planType="'integral'"
                :title="'INTEGRAL'"
                :hrColor="'#117e96'"
                :firstPrice="price.integral"
                :secondPrice="price.descuentoIntegral"
                :allData="forSendData"
                :info="[
                  'Un plan completo con prestaciones superadoras, con mínimos copagos.',
                  'Red de prestadores con diversas opciones.',
                  'Descuentos en medicamentos del 50% al 100%.',
                  '100% de cobertura en internaciones clínicas y quirúrgicas.',
                  'Emergencias, urgencias, médico a domicilio y traslados con copago.',
                  'Asistencia al viajero con tarifas bonificadas.',
                  'Sólo con el 3% del aporte personal de ley a partir del mínimo del plan.',
                  'Posibilidad de ascender de plan mediante el pago de un Aporte Complementario Mensual.',
                ]"
              />
            </slide>
            <slide>
              <PlanCard
                :planType="'premium'"
                :title="'PREMIUM'"
                :hrColor="'#fbb440'"
                :firstPrice="price.premium"
                :secondPrice="price.descuentoPremium"
                :allData="forSendData"
                :info="[
                  'Cobertura de calidad con prestaciones superadoras, sin copagos.',
                  'Amplia red de prestadores.',
                  'Descuentos en medicamentos del 70% al 100%.',
                  '100% de cobertura en internaciones clínicas y quirúrgicas en habitación privada.',
                  'Emergencias, urgencias, médico a domicilio y traslados sin copago.',
                  'Asistencia al viajero sin cargo.',
                  'Sólo con el 3% del aporte personal de ley a partir del mínimo del plan.',
                  'Posibilidad de acceder al plan mediante el pago de un Aporte Complementario Mensual.',
                ]"
              />
            </slide>
            <slide>
              <PlanCard
                :planType="''"
                :title="'NODOCENTE'"
                :hrColor="'#efefef'"
                :firstPrice="true"
                :allData="forSendData"
                :info="[
                  'Máximo nivel de cobertura sin copagos.',
                  'Amplia red de prestadores.',
                  'Descuentos en medicamentos del 70% al 100%.',
                  '100% de cobertura en internaciones clínicas y quirúrgicas en habitación privada.',
                  'Emergencias, urgencias, médico a domicilio y traslados sin copago.',
                  'Asistencia al viajero sin cargo.',
                  'Sólo con el 3% del aporte personal de ley.',
                  'Sin pago de Aporte Complementario Mensual',
                ]"
              />
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
          </hooper>
        </section>
        <section class="slider-container">
          <div class="plancard-nodocente"></div>
        </section>
      </section>
      <ul class="btn-control">
        <li>
          <CustomButton :clickFunction="reCotizar" text="Cotizar" />
        </li>
        <li>
          <a
            class="center button masInfo is-info"
            href="https://www.osfatun.com.ar/planes-y-servicios/"
            target="_blank"
            >Más información</a
          >
        </li>
      </ul>
      <!-- <PlanInfo /> -->
    </template>
  </main>
</template>

<script>
import PlanInfo from "./PlanInfo.vue";
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
import PlanCard from "./PlanCard";
import CustomButton from "./../utils/CustomButton";
// archivos csv

export default {
 
props: {
    responseData3: {
      type: Object,
      default: () => {},
    },
  },

  name: "PlanBody",
  components: {
    PlanCard,
    Hooper,
    Slide,
    HooperNavigation,
    CustomButton,
    PlanInfo,
  },

  data() {
    return {
      showDefaultPage: true,
      noDocenteDom: false,
      hooperSettings: {
        itemsToShow: 4,
        infiniteScroll: false,
        trimWhiteSpace: true,
        breakpoints: {
          411: {
            itemsToShow: 1,
          },
          1000: {
            itemsToShow: 4,
          },
        },
      },
      pCategory: "",
      forSendData: {
        leadID: this.leadID,
        person: this.pPerson,
        personPrice: this.pPrice,
        job: this.pJob,
        sons: this.pSons,
        partner: this.pPartner,
        newsletter: this.pNewsletter,
      },
      price: {
        total: "",
        uni1000: "",
        uni2000: "",
        uni3000: "",
        uni4000: "",
        
      },
    
    };
  },
  
  
  methods: {

    init(){
       this.price.uni1000 = Math.floor(this.responseData3.data.uni1000);
       this.price.uni2000 = Math.floor(this.responseData3.data.uni2000);
       this.price.uni3000 = Math.floor(this.responseData3.data.uni3000);
       this.price.uni4000 = Math.floor(this.responseData3.data.uni4000);
    },
 
  },

   reCotizar() {
      this.$store.commit("setPersonForm", this.forSendData.person);
      this.$router.push({
        name: "Cotizar",
      });
    },

  created() {
  
    this.showDefaultPage = false;
    this.init()
    
  },

   mounted() {
    console.log("Response data in Plan component:", this.responseData3);
  },
  
};
</script>
<style scoped>
button.center {
  display: block;
  margin: 10px auto;
  margin-bottom: 20px;
}
ul.btn-control {
  margin: 0 auto;
  text-align: center;
  padding: 0;
}
ul.btn-control li {
  display: inline-block;
  margin-right: 20px;
}
button {
  width: 100%;
  max-width: 195px !important;
  background: #00758f !important;
  border: 2px solid #00758f;
  color: #fff;
  text-transform: uppercase;
  border-radius: 0;
  display: block;
  margin: 0 auto;
}
.masInfo,
.masInfo:hover {
  margin-top: 1px !important;
  border: 2px solid #faae30;
  width: 100%;
  max-width: 195px !important;
  background: transparent !important;
  color: #00758f;
  text-transform: uppercase;
  border-radius: 0;
  display: block;
  margin: 0 auto;
}
.plancard-nodocente {
  max-width: 480px;
  margin: 0 auto;
}
.hooper {
  height: auto;
}
.slider-container {
  text-align: center;
}
.plan-init {
 position: relative;
    top: -15vh;
    background: white;
    max-width: 95%; /* Cambia el porcentaje según tus necesidades */
    padding: 40px 30px;
    margin: 0 auto;
}
.plan-init h3 {
  text-transform: uppercase;
}
h3.title {
  font-weight: bold;
  font-size: 22px;
  color: #00758f;
  line-height: 1.9rem;
  text-align: center;
  margin-bottom: 25px;
}
@media screen and (max-width: 480px) {
  .plan-init {
    position: relative;
    top: -2vh;
    background: white;
    max-width: 90%;
    padding: 40px 20px;
    margin: 0 auto;
  }
}
</style>
